// src/pages/App.jsx

import React from "react";
import ReCaptchaProvider from "./../components/ReCaptcha";
import { Helmet } from "react-helmet";
import Navbar from "./../components/Navbar";
import IndexPage from "./index";
import AboutPage from "./about";
import FaqPage from "./faq";
import ContactPage from "./contact";
import PricingPage from "./pricing";
import DashboardPage from "./dashboard";
import AuthPage from "./auth";
import SettingsPage from "./settings";
import LegalPage from "./legal";
import ProPage from "./pro";
import { Switch, Route, Router } from "./../util/router";
import FirebaseActionPage from "./firebase-action";
import NotFoundPage from "./404";
import Footer from "./../components/Footer";
import "./../util/analytics";
import { AuthProvider } from "./../util/auth";
import { ThemeProvider } from "./../util/theme";
import { QueryClientProvider } from "./../util/db";
import logo_image from "./../images/logo.png";
import { makeStyles } from "@material-ui/core/styles";

// Import PurchasePage from the dynamic route
import PurchasePage from "./purchase/[plan]";

const useStyles = makeStyles((theme) => ({
  appContainer: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  toolbarOffset: theme.mixins.toolbar,
}));

function App(props) {
  const classes = useStyles();

  return (
    <>
      {/* Global SEO Meta Tags */}
      <Helmet>
        <meta charSet="utf-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        {/* Additional global meta tags can be added here */}
      </Helmet>

      <ReCaptchaProvider>
        <QueryClientProvider>
          <ThemeProvider>
            <AuthProvider>
              <Router>
                <div className={classes.appContainer}>
                  {/* Navbar at the top */}
                  <Navbar
                    color="default"
                    logo={logo_image}
                    logoInverted={logo_image}
                  />

                  {/* Offset for the fixed Navbar */}
                  <div className={classes.toolbarOffset} />

                  {/* Main content area */}
                  <div className={classes.content}>
                    <Switch>
                      <Route exact path="/" component={IndexPage} />
                      <Route exact path="/about" component={AboutPage} />
                      <Route exact path="/faq" component={FaqPage} />
                      <Route exact path="/contact" component={ContactPage} />
                      <Route exact path="/pricing" component={PricingPage} />
                      <Route
                        exact
                        path="/dashboard"
                        component={DashboardPage}
                      />
                      <Route exact path="/auth/:type" component={AuthPage} />
                      <Route
                        exact
                        path="/settings/:section"
                        component={SettingsPage}
                      />
                      <Route
                        exact
                        path="/legal/:section"
                        component={LegalPage}
                      />
                      <Route exact path="/pro" component={ProPage} />
                      {/* Updated Route for PurchasePage */}
                      <Route
                        exact
                        path="/purchase/:plan"
                        component={PurchasePage}
                      />
                      <Route
                        exact
                        path="/firebase-action"
                        component={FirebaseActionPage}
                      />
                      <Route component={NotFoundPage} />
                    </Switch>
                  </div>

                  {/* Footer at the bottom */}
                  <Footer
                    bgColor="light"
                    size="normal"
                    bgImage=""
                    bgImageOpacity={1}
                    description="A short description of what you do here"
                    copyright={`© ${new Date().getFullYear()} Resume Revival`}
                    logo={logo_image}
                    logoInverted={logo_image}
                    sticky={true}
                  />
                </div>
              </Router>
            </AuthProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </ReCaptchaProvider>
    </>
  );
}

export default App;
